// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"b7b4ea5a","959":"45d8d3d4"}[chunkId] + ".chunk.js";
};